import { RelationGeography, RelationGeographyInner } from '../../../swagger-api';

export function calculateRelationsCount(relationGeography: RelationGeography): number {
  return relationGeography.reduce(
    (total: number, relationGeographyInner: RelationGeographyInner) => total + relationGeographyInner.count,
    0,
  );
}
